import React from 'react';
import Header from './Header'; 
import Footer from './Footer'; 
import '../styles/Layout.css';
import TopBanner from './TopBanner';
const Layout = ({ children }) => {
  return (
    <div className="wrapper">
      <div className="content">
        <Header />
        <TopBanner />
        <main>{children}</main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
